export default function buildPageTitle(pageTitle, orgTitle) {
  const validOrgTitle = orgTitle && orgTitle !== 'false' ? orgTitle : '';
  return [pageTitle, validOrgTitle].map((s) => s.trim()).filter(Boolean).join(' - ') || 'Home';
}
